/**
 * Extracts filename from Content-Disposition header.
 * Prefers RFC 5987 filename* (UTF-8 encoded) over plain filename.
 */
export function getFilenameFromContentDisposition(
    header?: string,
): string | undefined {
    if (!header) {
        return undefined;
    }

    const filenameStarMatch = /filename\*=UTF-8''([^\s;]+)/i.exec(header);
    if (filenameStarMatch) {
        try {
            return decodeURIComponent(filenameStarMatch[1]);
        } catch {
            // Malformed percent-encoding — fall through to plain filename
        }
    }

    return /filename="([^"]+)"/.exec(header)?.[1];
}
